/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';

const Hero = () => {
  return (
    <Box>
      <Box marginBottom={4}>
        <Box marginBottom={2}>
          <Typography
            variant='h4'
            align='center'
          >
            ADMISSION GUIDELINES
            <br />
            <br />
          </Typography>

          <Typography component='div' sx={{ fontSize: '1.08rem', lineHeight: 1.8 }}>
            <Box component='span' sx={{ fontWeight: 800, fontSize: '1.32rem', display: 'block' }}>
              <strong>Welcome to National Public School, Yeshwanthpur.</strong>
            </Box>
            <br />
            We are an educational institution committed to preparing students for a rapidly changing world by nurturing essential skills, fostering a global perspective, and inculcating core values of respect, honesty, loyalty, perseverance and compassion.<br /><br />
            Admissions to National Public School, Yeshwanthpur, are open to students seeking entry into Montessori I to III (I-5 Academy), Pre-K, Kindergarten I and II and Classes 1 to 9 and 11.<br /><br />

            <strong>A. APPLY FOR ADMISSION</strong><br /><br />
            We invite you to register your interest by submitting the application form online through our school website. <Link href='https://online-registrations.npsypr.edu.in/' target='_blank' sx={{ fontWeight: 700, color: 'primary.main', textDecoration: 'underline' }}>Click Here.</Link><br /><br />
            Online Registration fee of Rs 700/- is non-refundable.<br /><br />

            <strong>FOR Class 11 ADMISSION</strong><br /><br />
            Class 11 admissions are open for the Science, Commerce, and Humanities streams, offering a range of thoughtfully designed subject combinations that empower students to pursue their interests and build strong foundations for diverse career pathways.<br /><br />

            <strong>Class 11 SCIENCE - INSPIRE (NEET/JEE/CET)</strong><br /><br />
            National Public School, Yeshwanthpur has designed an Integrated Course for Class 11 to provide students with a strong foundation in the CBSE curriculum while simultaneously preparing them for competitive entrance examinations (NEET/JEE/CET). The programme integrates board-focused teaching with application-based learning, ensuring conceptual clarity, academic rigor and exam readiness within regular school hours. The course is supported by experienced faculty, structured assessments, regular revision and continuous academic mentoring. This integrated approach enables students to effectively balance the CBSE curriculum with competitive examination preparation within the stipulated time, while developing the skills, discipline and confidence required to excel.<br /><br />

            <strong>B. AGE CRITERIA</strong><br /><br />
            Kindly note the age criteria as on 1st June 2027:<br /><br />
            - For Montessori I and Pre-K registration, the student should have completed 3 years.<br />
            - For Montessori II and Kindergarten I registration, the student should have completed 4 years.<br />
            - For Montessori III and Kindergarten II registration, the student should have completed 5 years.<br />
            - For Class 1 registration, the student age should have completed 6 years.<br /><br />
            Note: Age relaxation, wherever applicable, shall be considered strictly in accordance with the prevailing government norms.<br /><br />

            <strong>C. SELECTION PROCESS</strong><br /><br />
            We appreciate the interest evinced by the parents seeking admission at National Public School Yeshwanthpur. We would like to inform that we have very limited seats available for admission to all of the classes from Classes 1 to 9 and 11. The seats will be available in the open category according to the priority list given below:<br /><br />
            - First priority: Siblings of students currently studying in the school.<br />
            - Second priority: Children of teaching and non-teaching staff members of the school.<br />
            - Third priority: Children of alumni of National Public School.<br />
            - Subsequent priority: Other applicants, subject to the availability of seats.<br />
            - Classes 1 to 9 and 11: Admissions will be based on the availability of vacancies.<br />
            - Classes 10 and 12: Registrations will be considered only in cases of interstate transfer, subject to the applicable admission requirements.<br />
            - Due consideration will be given to students with academic merit and overall achievement, with distinguished accomplishments in co-curricular activities and State/National-level sports.<br /><br />
            Parents seeking admission are advised to submit their applications at the earliest, as applications will be considered on a first-come, first-served basis, subject to eligibility and the availability of vacancies.<br /><br />
            In keeping with the School's commitment to providing an optimal learning environment, each section is limited to a maximum strength of 32 students. Prospective applicants and parents are therefore kindly requested to understand and appreciate the admission constraints of the institution.<br /><br />

            <strong>D. DOCUMENT REQUIRED ON THE DAY OF INTERACTION</strong><br /><br />
            Download the completed Registration form and submit the printout along with the parent-attested copies of the following documents on the day of interaction (for pre-primary) and on the day of entrance test (for Classes 1 to 9 & 11):<br /><br />
            1. Student's Birth Certificate.<br />
            2. Immunisation Card (applicable to Class 1 and below).<br />
            3. Class 1 and above: Previous two years' Academic Progress Reports and the current year's Term 1 Academic Progress Report.<br />
            4. Kindergarten II and Montessori III: Previous year's Academic Progress Report / Study Certificate and the current year's Term 1 Academic Progress Report / Study Certificate.<br />
            5. Kindergarten I and Montessori II: Current Study Certificate.<br />
            6. Student’s and Parents’ Aadhaar Cards.<br />
            7. Foreign Nationals: A copy of the student's passport, duly attested by both parents.<br /><br />
            Note: Incomplete applications or applications without the required supporting documents will not be considered.<br /><br />
            Entrance test dates will be notified via email to the applicant's registered email id.<br /><br />
            Note: Kindly add <Link href='mailto:info@npsypr.edu.in' sx={{ fontWeight: 800, fontSize: '1.08rem', color: 'primary.main', textDecoration: 'underline' }}>info@npsypr.edu.in</Link> and <Link href='mailto:admissions@npsypr.edu.in' sx={{ fontWeight: 800, fontSize: '1.08rem', color: 'primary.main', textDecoration: 'underline' }}>admissions@npsypr.edu.in</Link> to your contact list to avoid any confusion.<br /><br />

            <strong>Address for Communication</strong><br />
            NATIONAL PUBLIC SCHOOL<br />
            No. 9/1, Pipeline Road, Raghavendra Layout, Yeshwanthpur, Bengaluru - 560-022<br />
            Phone:
            +91-080-23571220 / 29501184<br /><br />
            What's app: +91-6364071122<br />
            Email: <Link href='mailto:info@npsypr.edu.in' sx={{ fontWeight: 800, fontSize: '1.12rem', color: 'primary.main', textDecoration: 'underline' }}>info@npsypr.edu.in</Link><br /><br />
            <strong>Google Map</strong><br /><br />
          </Typography>

          <Box sx={{ width: '100%', height: '420px', marginTop: 2 }}>
            <iframe
              title='National Public School Yeshwanthpur Map'
              src='https://www.google.com/maps?q=No.%209/1,%20Pipeline%20Road,%20Raghavendra%20Layout,%20Yeshwanthpur,%20Bengaluru%20560%20022&output=embed'
              width='100%'
              height='100%'
              style={{ border: 0, borderRadius: 8 }}
              allowFullScreen=''
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
            ></iframe>
          </Box>
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretched', sm: 'center' }}
          justifyContent={'center'}
        >
          <Box
            marginTop={{ xs: 2, sm: 0 }}
            marginLeft={{ sm: 2 }}
            width={{ xs: '100%', md: 'auto' }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
